"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
const store_1 = require("client/modules/users/store");
class BillingStore {
    constructor() {
        this.showLoader = false;
        /** Query Actions */
        this.getStatementsById = async (siteId = store_1.usersStore.user.value.siteId, limit) => {
            const statements = await api_1.BillingEndpoint.getStatements.apiCall(null, {
                limit,
                siteId
            });
            if (api_1.isError(statements)) {
                this.showLoader = false;
                console.log("error in loading billing statements:", statements.code);
                alert(`Error in loading statements: ${statements.code}`);
                return null;
            }
            this.showLoader = false;
            return statements.statements;
        };
        this.getSelectedStatement = async (siteId = store_1.usersStore.user.value.siteId, statementId = 0) => {
            const statements = await api_1.BillingEndpoint.getSelectedStatement.apiCall(null, {
                siteId,
                statementId
            });
            if (api_1.isError(statements)) {
                this.showLoader = false;
                console.log("error in loading billing statements:", statements.code);
                alert(`Error in loading statements: ${statements.code}`);
                return null;
            }
            this.showLoader = false;
            return statements.statements;
        };
        /** End Query Actions */
    }
}
__decorate([
    mobx_1.observable
], BillingStore.prototype, "showLoader", void 0);
exports.billingStore = new BillingStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/billing/store.ts
// module id = 3283
// module chunks = 0